import { useQuery } from '@tanstack/react-query';

import { extractErrorMessage } from '@/api/extractErrorMessage';
import { gqlClient } from '@/api/graphql-client';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import { GetProposalInput } from '@/gql/graphql';

const GET_PROPOSAL_LOCATION = graphql(`
  query GetProposalLocation($input: GetProposalInput!) {
    proposal(input: $input) {
      id
      publicId
      project {
        id
        publicId
        version
      }
    }
  }
`);

/** Where a Proposal lives, by either of its ids. */
export const useGetProposalLocation = (id?: GetProposalInput['id']) => {
  const { data, ...rest } = useQuery({
    enabled: !!id,
    queryKey: proposalKeys.proposalLocation(String(id)),
    queryFn: () =>
      gqlClient.request(GET_PROPOSAL_LOCATION, { input: { id: id! } }),
    // A client can hold the id of a Proposal it can no longer reach — a deleted
    // one, a legacy Invoice, another Account's — so failure is a normal outcome
    // here rather than a fault, and retrying cannot recover it.
    retry: (failureCount, error) =>
      failureCount < 3 && extractErrorMessage(error).code !== 'NOT_FOUND',
  });

  return { proposal: data?.proposal, ...rest };
};
